const COMBEE_URL = process.env.COMBEE_URL;

export const OIDC_PARAM = 'uid';

export type OidcInteractionAction = 'login' | 'confirm' | 'abort';

export async function oidcPostInteraction(
  uid: string,
  action: OidcInteractionAction,
  options: { jwt?: string; body?: unknown } = {},
): Promise<void> {
  const { jwt, body } = options;
  const headers: Record<string, string> = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (jwt) headers.Authorization = `Bearer ${jwt}`;

  const response = await fetch(`${COMBEE_URL}/interaction/${uid}/${action}`, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`OIDC interaction ${action} failed: ${response.status}`);
  }
  const data = (await response.json()) as { redirectTo?: string };
  if (!data.redirectTo) {
    throw new Error(`OIDC interaction ${action} response missing redirectTo`);
  }
  window.location.href = data.redirectTo;
}

export async function oidcGetInteraction(uid: string, jwt?: string): Promise<any> {
  const headers: Record<string, string> = {};
  if (jwt) headers.Authorization = `Bearer ${jwt}`;

  const response = await fetch(`${COMBEE_URL}/interaction/${uid}`, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
  if (!response.ok) {
    throw new Error(`OIDC interaction GET failed: ${response.status}`);
  }
  return response.json();
}
